export default __webpack_public_path__ + "static/media/edu.6816c035.jpg";